export const USERS_GROUP_LABEL = "Usuarios";
export const DOCUMENTS_GROUP_LABEL = "Documentos";
export const EMAIL_GROUPS_GROUP_LABEL = "Grupos de Correo";
export const DOCUMENT_VERIFICATIONS_GROUP_LABEL = "Verificación de Documentos";

// Users permissions
export const USERS_RETRIEVE = "users.retrieve";
export const USERS_RETRIEVE_LABEL = "Leer";
export const USERS_CREATE = "users.create";
export const USERS_CREATE_LABEL = "Crear";
export const USERS_UPDATE = "users.update";
export const USERS_UPDATE_LABEL = "Editar";
export const USERS_DESTROY = "users.destroy";
export const USERS_DESTROY_LABEL = "Eliminar";

// Assets permissions
export const ASSETS_RETRIEVE = "assets.retrieve";
export const ASSETS_RETRIEVE_LABEL = "Leer";
export const ASSETS_CREATE = "assets.create";
export const ASSETS_CREATE_LABEL = "Crear";
export const ASSETS_UPDATE = "assets.update";
export const ASSETS_UPDATE_LABEL = "Editar";
export const ASSETS_DESTROY = "assets.destroy";
export const ASSETS_DESTROY_LABEL = "Eliminar";

export const COMPANIES_ADDITIONAL_FIELDS_RETRIEVE =
  "companies_additional_fields.retrieve";
export const COMPANIES_ADDITIONAL_FIELDS_RETRIEVE_LABEL = "Leer";
export const COMPANIES_ADDITIONAL_FIELDS_UPDATE =
  "companies_additional_fields.update";
export const COMPANIES_ADDITIONAL_FIELDS_UPDATE_LABEL = "Editar";

// Documents permissions
export const DOCUMENTS_RETRIEVE = "documents.retrieve";
export const DOCUMENTS_RETRIEVE_LABEL = "Leer";
export const DOCUMENTS_CREATE = "documents.create";
export const DOCUMENTS_CREATE_LABEL = "Crear";
export const DOCUMENTS_UPDATE = "documents.update";
export const DOCUMENTS_UPDATE_LABEL = "Editar";
export const DOCUMENTS_DESTROY = "documents.destroy";
export const DOCUMENTS_DESTROY_LABEL = "Eliminar";

// Document Verifications permissions
export const DOCUMENT_VERIFICATIONS_RETRIEVE =
  "document_verifications.retrieve";
export const DOCUMENT_VERIFICATIONS_RETRIEVE_LABEL = "Leer";
export const DOCUMENT_VERIFICATIONS_CREATE = "document_verifications.create";
export const DOCUMENT_VERIFICATIONS_CREATE_LABEL = "Crear";
export const DOCUMENT_VERIFICATIONS_UPDATE = "document_verifications.update";
export const DOCUMENT_VERIFICATIONS_UPDATE_LABEL = "Editar";
export const DOCUMENT_VERIFICATIONS_DESTROY = "document_verifications.destroy";
export const DOCUMENT_VERIFICATIONS_DESTROY_LABEL = "Eliminar";

// Email groups permissions
export const EMAIL_GROUPS_RETRIEVE = "email_groups.retrieve";
export const EMAIL_GROUPS_RETRIEVE_LABEL = "Leer";
export const EMAIL_GROUPS_CREATE = "email_groups.create";
export const EMAIL_GROUPS_CREATE_LABEL = "Crear";
export const EMAIL_GROUPS_UPDATE = "email_groups.update";
export const EMAIL_GROUPS_UPDATE_LABEL = "Editar";
export const EMAIL_GROUPS_DESTROY = "email_groups.destroy";
export const EMAIL_GROUPS_DESTROY_LABEL = "Eliminar";

// Permission groups
export const PERMISSION_GROUPS: Map<
  string,
  { value: string; label: string }[]
> = new Map([
  [
    USERS_GROUP_LABEL,
    [
      { value: USERS_RETRIEVE, label: USERS_RETRIEVE_LABEL },
      { value: USERS_CREATE, label: USERS_CREATE_LABEL },
      { value: USERS_UPDATE, label: USERS_UPDATE_LABEL },
      { value: USERS_DESTROY, label: USERS_DESTROY_LABEL },
    ],
  ],
  [
    DOCUMENTS_GROUP_LABEL,
    [
      { value: DOCUMENTS_RETRIEVE, label: DOCUMENTS_RETRIEVE_LABEL },
      { value: DOCUMENTS_CREATE, label: DOCUMENTS_CREATE_LABEL },
      { value: DOCUMENTS_UPDATE, label: DOCUMENTS_UPDATE_LABEL },
      { value: DOCUMENTS_DESTROY, label: DOCUMENTS_DESTROY_LABEL },
    ],
  ],
  [
    DOCUMENTS_GROUP_LABEL,
    [
      { value: DOCUMENTS_RETRIEVE, label: DOCUMENTS_RETRIEVE_LABEL },
      { value: DOCUMENTS_CREATE, label: DOCUMENTS_CREATE_LABEL },
      { value: DOCUMENTS_UPDATE, label: DOCUMENTS_UPDATE_LABEL },
      { value: DOCUMENTS_DESTROY, label: DOCUMENTS_DESTROY_LABEL },
    ],
  ],
  [
    DOCUMENT_VERIFICATIONS_GROUP_LABEL,
    [
      {
        value: DOCUMENT_VERIFICATIONS_RETRIEVE,
        label: DOCUMENT_VERIFICATIONS_RETRIEVE_LABEL,
      },
      {
        value: DOCUMENT_VERIFICATIONS_CREATE,
        label: DOCUMENT_VERIFICATIONS_CREATE_LABEL,
      },
      {
        value: DOCUMENT_VERIFICATIONS_UPDATE,
        label: DOCUMENT_VERIFICATIONS_UPDATE_LABEL,
      },
      {
        value: DOCUMENT_VERIFICATIONS_DESTROY,
        label: DOCUMENT_VERIFICATIONS_DESTROY_LABEL,
      },
    ],
  ],
  [
    EMAIL_GROUPS_GROUP_LABEL,
    [
      { value: EMAIL_GROUPS_RETRIEVE, label: EMAIL_GROUPS_RETRIEVE_LABEL },
      { value: EMAIL_GROUPS_CREATE, label: EMAIL_GROUPS_CREATE_LABEL },
      { value: EMAIL_GROUPS_UPDATE, label: EMAIL_GROUPS_UPDATE_LABEL },
      { value: EMAIL_GROUPS_DESTROY, label: EMAIL_GROUPS_DESTROY_LABEL },
    ],
  ],
]);

export const ALL_PERMISSIONS: string[] = [
  USERS_RETRIEVE,
  USERS_CREATE,
  USERS_UPDATE,
  USERS_DESTROY,
  ASSETS_RETRIEVE,
  ASSETS_CREATE,
  ASSETS_UPDATE,
  ASSETS_DESTROY,
  DOCUMENTS_RETRIEVE,
  DOCUMENTS_CREATE,
  DOCUMENTS_UPDATE,
  DOCUMENTS_DESTROY,
  DOCUMENT_VERIFICATIONS_RETRIEVE,
  DOCUMENT_VERIFICATIONS_CREATE,
  DOCUMENT_VERIFICATIONS_UPDATE,
  DOCUMENT_VERIFICATIONS_DESTROY,
  EMAIL_GROUPS_RETRIEVE,
  EMAIL_GROUPS_CREATE,
  EMAIL_GROUPS_UPDATE,
  EMAIL_GROUPS_DESTROY,
];

export const ROLE_READER = "reader";
export const ROLE_READER_LABEL = "Solo Lectura";
export const ROLE_OPERATOR = "operator";
export const ROLE_OPERATOR_LABEL = "Operador";
export const ROLE_ADMIN = "admin";
export const ROLE_ADMIN_LABEL = "Administrador";
export const ROLE_SUPERUSER = "superuser";
export const ROLE_SUPERUSER_LABEL = "Superusuario";

export const ROLE_PERMISSIONS: Record<string, string[]> = {
  [ROLE_READER]: [
    ASSETS_RETRIEVE,
    DOCUMENTS_RETRIEVE,
    DOCUMENT_VERIFICATIONS_RETRIEVE,
  ],
  [ROLE_OPERATOR]: [
    USERS_RETRIEVE,
    ASSETS_RETRIEVE,
    DOCUMENTS_RETRIEVE,
    DOCUMENTS_CREATE,
    DOCUMENTS_UPDATE,
    DOCUMENT_VERIFICATIONS_RETRIEVE,
    DOCUMENT_VERIFICATIONS_CREATE,
    DOCUMENT_VERIFICATIONS_UPDATE,
  ],
  [ROLE_ADMIN]: [
    USERS_RETRIEVE,
    USERS_CREATE,
    USERS_UPDATE,
    ASSETS_RETRIEVE,
    ASSETS_CREATE,
    ASSETS_UPDATE,
    DOCUMENTS_RETRIEVE,
    DOCUMENTS_CREATE,
    DOCUMENTS_UPDATE,
    DOCUMENT_VERIFICATIONS_RETRIEVE,
    DOCUMENT_VERIFICATIONS_CREATE,
    DOCUMENT_VERIFICATIONS_UPDATE,
    EMAIL_GROUPS_RETRIEVE,
    EMAIL_GROUPS_CREATE,
    EMAIL_GROUPS_UPDATE,
  ],
  [ROLE_SUPERUSER]: ALL_PERMISSIONS,
};

export const ROLES: Map<string, string> = new Map([
  [ROLE_READER, ROLE_READER_LABEL],
  [ROLE_OPERATOR, ROLE_OPERATOR_LABEL],
  [ROLE_ADMIN, ROLE_ADMIN_LABEL],
  [ROLE_SUPERUSER, ROLE_SUPERUSER_LABEL],
]);
